import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { QRURLModal, QRDownloadModal } from "../modals";
import { ConfirmationModal, Input, RowInfo } from "../../common";
import { Button } from "../../App.styles";
import { downloadBlob } from "../../lib/blob";
import usePrevious from '../../hooks/usePrevious'

const whitelabel = process.env.REACT_APP_WHITELABEL;

const QRCode = ({ useQuery, game_id, id }) => {
    const { t } = useTranslation();
    const [valueChanged, setValueChanged] = useState(false);
    const [collection] = useQuery();
    const prevQrUrl = usePrevious(collection?.qr_url);
    const isDevelopment = (
        window.location.hostname === 'staging-builder.socialscavenger.com' ||
        process.env.NODE_ENV === 'development'
    )
    const downloadEnv = isDevelopment ? 'staging' : 'v1'
    const downloadUrl = `https://app.socialscavenger.com/${downloadEnv}/tasks/${id}/qr.png?whitelabel=${whitelabel}&game_id=${game_id}`

    useEffect(() => {
        if (prevQrUrl !== undefined && prevQrUrl !== collection?.qr_url) {
            setValueChanged(true)
        }
    }, [collection?.qr_url, prevQrUrl])

    return (
        <>
            <p>{t('Require the player to scan the exact QR image.')}</p>
            <RowInfo help={<QRURLModal />}>
                <Input
                    label={t("URL to open")}
                    name="qr_url"
                    useQuery={useQuery}
                />
            </RowInfo>
            <RowInfo help={<QRDownloadModal />} hasLabel={false}>
                {
                    valueChanged
                        ? (
                            <ConfirmationModal
                                title={t("QR Code")}
                                body={t("You have changed the challenge definition such that a new QR code will be required. Please download the new QR code.")}
                                confirmLabel={t("Download")}
                                confirmAction={() => {
                                    downloadBlob(downloadUrl, 'QR Code')
                                    setValueChanged(false)
                                }}
                            >
                                <Button
                                    className="btn--flat btn--wrap mt-2"
                                    color="warning"
                                >
                                    {t('Download the QR code image.')}
                                </Button>
                            </ConfirmationModal>
                        )
                        : (
                            <Button
                                className="btn--flat btn--wrap mt-2"
                                color="warning"
                                onClick={() => {
                                    downloadBlob(downloadUrl, 'QR Code')
                                }}
                            >
                                {t('Download the QR code image.')}
                            </Button>
                        )
                }
            </RowInfo>
        </>
    )
};

export default QRCode;
